import React, { useEffect, useState,useRef } from "react";
import { Button, Row, Col, Form,  } from "react-bootstrap";
import AxiosInstance from "../AxiosInstance";
import Layout from "./Layout";
import { FaSyncAlt,FaEye  } from "react-icons/fa"; 
import { useNavigate,useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ToastNotification from "../ToastNotification";

const getCurrentMonthYear = () => {
  const today = new Date();
  return {
    currentMonth: today.getMonth() + 1,
    currentYear: today.getFullYear(),
  };
};


const Timesheet = () => {
  const toastRef = useRef(null);
  const [performanceData, setPerformanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState(() => sessionStorage.getItem("searchTerm") || "");
  const [activeTab, setActiveTab] = useState(() => sessionStorage.getItem("activeTab") || "pending");
  const { currentMonth, currentYear } = getCurrentMonthYear();

  const [selectedDate, setSelectedDate] = useState(() => {
    const storedMonth = sessionStorage.getItem("selectedMonth");
    const storedYear = sessionStorage.getItem("selectedYear");
    return storedMonth && storedYear
      ? new Date(Number(storedYear), Number(storedMonth) - 1)
      : new Date();
  });
  
  // Fetch timesheets when the component mounts
  useEffect(() => {
    const month = selectedDate.getMonth() + 1;
    const year = selectedDate.getFullYear();

    if (location.state?.selectedMonth && location.state?.selectedYear) {
      fetchTimesheets(location.state.selectedMonth, location.state.selectedYear);
    } else {
      fetchTimesheets(month, year);
    }
  }, [location.state, selectedDate]);

  const fetchTimesheets = async (month, year) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.get(
        `/admin/getSubmittedTimesheets?selectedMonth=${month}&selectedYear=${year}`
      );
      setPerformanceData(response.data.performanceData || []);
    } catch (error) {
      toastRef.current.showToast("Failed to fetch timesheets.", "error");
    } finally {
      setLoading(false);

    }
  };


const handleRefresh = () => {
  setSearchTerm("");
  setSelectedDate(new Date());

  sessionStorage.removeItem("searchTerm");
  sessionStorage.removeItem("selectedMonth");
  sessionStorage.removeItem("selectedYear");

  fetchTimesheets(currentMonth, currentYear);
  navigate("/timesheet", { replace: true });
};

// Filter performance data based on status and search term
const filterTimesheets = (status) => {
  return performanceData.filter((sheet) => {
    if (!sheet || !sheet.status_name) return false;
    return (
      sheet.status_name === status && 
      (searchTerm === "" ||
        (sheet.employee_name && sheet.employee_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        sheet.status_name.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  });
};


const navigateToDetails = (username, weekStart, weekEnd) => {
  const formatDate = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  };

  const formattedWeekStart = formatDate(weekStart);
  const formattedWeekEnd = formatDate(weekEnd);
  
  sessionStorage.setItem("selectedMonth", selectedDate.getMonth() + 1);
  sessionStorage.setItem("selectedYear", selectedDate.getFullYear());
  sessionStorage.setItem("weekStart", formattedWeekStart);
  sessionStorage.setItem("weekEnd", formattedWeekEnd);
  sessionStorage.setItem("searchTerm", searchTerm);
  sessionStorage.setItem("activeTab", activeTab);

  navigate("/details", {
    state: {
      username,
      startDate: formattedWeekStart,
      endDate: formattedWeekEnd,
      status: activeTab,
    },
  });
};

  const formatDate = (date) => {
    const d = new Date(date);
  return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}-${d.getFullYear()}`;
};

const capitalizeName = (name) => {
  if (!name) return ''; 
  return name
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};



return (
    <Layout heading="Timesheet">
    <div className="container-fluid px-3">
      {/* Date Filter Section */}
      <Row className="mb-3">
          {/* Month-Year Picker */}
          <Col xs={12} md={4} className="mb-2 mb-md-0">
            <Form.Group controlId="datePicker">
              <Form.Label>Select Month & Year</Form.Label>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                className="form-control"
              />
            </Form.Group>
          </Col>
        {/* Action Buttons */}
        <Col xs={12} md={4} className="d-flex align-items-end justify-content-md-start justify-content-sm-center">
          <Button variant="light" onClick={handleRefresh}>
          Refresh <FaSyncAlt size={20} />
          </Button>
        </Col>
      </Row>
      {/* Search Bar */}
      <Row className="mb-3 justify-content-md-start justify-content-center">
        <Col xs={12} md={6}>
          <Form.Group controlId="searchBar">
            <Form.Control
              type="text"
              placeholder="Search by Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      {/* Tabs */}
      <div className="row">
  <div className="col-12">
    <ul className="nav nav-tabs flex-column flex-md-row">
      {["pending", "accepted", "rejected", "saved"].map((tab) => (
        <li className="nav-item col-12 col-md-auto p-1" key={tab}>
          <button
            className={`nav-link w-100 ${activeTab === tab ? "active" : "text-dark"}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        </li>
      ))}
    </ul>
  </div>
</div>

      {/* Timesheet Table */}
      {/* Mobile view: Scrollable table for small screens */}
<div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
  <table className="table table-hover text-center align-middle table-striped">
    <thead className="table-primary">
      <tr>
        <th>Employee</th>
        <th>Week</th>
        <th>Hours</th>
        {["pending", "saved"].includes(activeTab) && <th>Action</th>}
        {activeTab === "rejected" && <th>Reason</th>}
      </tr>
    </thead>
    <tbody>
      {filterTimesheets(activeTab)?.length === 0 ? (
        <tr>
          <td colSpan={activeTab === "rejected" ? 4 : 4} className="text-muted">No timesheets found.</td>
        </tr>
      ) : (
        filterTimesheets(activeTab).map((sheet, index) => (
          <tr key={index}>
            <td
              className="text-start"
              onClick={() => navigateToDetails(sheet.username, sheet.week_start, sheet.week_end)}
              style={{ cursor: "pointer" }}
            >
              {sheet.employee_name.split(" ").map(capitalizeName).join(" ")}
            </td>
            <td className="text-start">{`${formatDate(sheet.week_start)} / ${formatDate(sheet.week_end)}`}</td>
            <td>{sheet.total_hours || "N/A"}</td>
            {["pending", "saved"].includes(activeTab) && (
              <td>
                <Button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateToDetails(sheet.username, sheet.week_start, sheet.week_end);
                  }}
                  disabled={loading}
                >
                  <FaEye />
                </Button>
              </td>
            )}
            {activeTab === "rejected" && (
              <td className="text-start">{sheet.rejected_reason || "No reason provided"}</td>
            )}
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

{/* Desktop view: Full table */}
<div className="table-responsive d-none d-md-block">
  <table className="table table-hover text-center align-middle table-striped">
    <thead className="table-primary">
      <tr>
        <th>Employee Name</th>
        <th>Week Range</th>
        <th>Total Hours</th>
        {["pending", "saved"].includes(activeTab) && <th>Actions</th>}
        {activeTab === "rejected" && <th>Rejection Reason</th>}
      </tr>
    </thead>
    <tbody>
      {filterTimesheets(activeTab)?.length === 0 ? (
        <tr>
          <td colSpan={activeTab === "rejected" ? 4 : 4} className="text-muted">No timesheets found.</td>
        </tr>
      ) : (
        filterTimesheets(activeTab).map((sheet, index) => (
          <tr key={index}>
            <td
              onClick={() => navigateToDetails(sheet.username, sheet.week_start, sheet.week_end)}
              style={{ cursor: "pointer" }}
            >
              {sheet.employee_name.split(" ").map(capitalizeName).join(" ")}
            </td>
            <td>{`${formatDate(sheet.week_start)} / ${formatDate(sheet.week_end)}`}</td>
            <td>{sheet.total_hours || "N/A"}</td>
            {["pending", "saved"].includes(activeTab) && (
              <td>
                <Button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigateToDetails(sheet.username, sheet.week_start, sheet.week_end);
                  }}
                  disabled={loading}
                >
                  <FaEye />
                </Button>
              </td>
            )}
            {activeTab === "rejected" && (
              <td>{sheet.rejected_reason || "No reason provided"}</td>
            )}
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

    </div>
      <ToastNotification/>
    </Layout>
  );
};

export default Timesheet;
